module.exports = __webpack_public_path__ + "img/kehu_zhongguoyouzheng.7505f046.png";